/**
 * GreenSide News brand assets.
 *
 * Reusable across the whole site so every surface pulls from one place:
 * - BRAND_MARK_URL        transparent G emblem (header mark, favicon)
 * - BRAND_LOCKUP_URL      full horizontal lockup logo
 * - BRAND_SOCIAL_URL      circular badge for social / profile images
 */

export const BRAND_MARK_URL =
  'https://public.readdy.ai/ai/img_res/bb62db24-49ad-48e2-a837-69a1031a02ff.png';

export const BRAND_LOCKUP_URL =
  'https://public.readdy.ai/ai/img_res/98589004-6d5c-42a5-ad4f-2854694e2436.png';

export const BRAND_SOCIAL_URL =
  'https://public.readdy.ai/ai/img_res/edited_89c1ef3919ac07c5f87259695ec57d2f_eea90ec2.jpg';